export default "__VITE_ASSET__InZW1MtsRotBT0uG0SO3sQ__"